<template>
	<div class="vx-row">
		<div class="vx-col w-full">
			
			<!-- <div class="mb-6">
				<strong class="block mb-4">Tipe Pengajuan Dana</strong>
				<v-select
					class="w-full rounded-lg"
					v-validate="'required'"
					name="tipe"
					v-model="tipe"
					:options="tipeOptions"
				/>
				<span class="text-danger text-sm" v-show="errors.has('tipe')">
					<strong>{{ errors.first('tipe') }}</strong>
				</span>
			</div> -->

			<div class="mb-6">
				<strong class="block mb-4">Jumlah Dana</strong>
				<vs-input
					type="number"
					class="w-full rounded-lg"
					v-validate="'required|min_value:1000'"
					name="jumlah_kebutuhan"
					:danger="errors.has('jumlah_kebutuhan')"
					v-model="jumlah_kebutuhan"
				/>
				<span class="text-danger text-sm" v-show="errors.has('jumlah_kebutuhan')">
					<strong>{{ errors.first('jumlah_kebutuhan') }}</strong>
				</span>
			</div>

			<div class="mb-6">
				<strong class="block mb-4">Kebutuhan</strong>
				<vs-textarea
					class="w-full rounded-lg"
					v-model="deskripsi_kebutuhan"
					name="deskripsi_kebutuhan"
					v-validate="'required'"
					:danger="errors.has('deskripsi_kebutuhan')"
				/>
				<span class="text-danger text-sm" v-show="errors.has('deskripsi_kebutuhan')">
					<strong>{{ errors.first('deskripsi_kebutuhan') }}</strong>
				</span>
			</div>
			<div class="mb-6">
				<strong class="block mb-4">Keterangan</strong>
				<vs-textarea
					class="w-full rounded-lg"
					v-model="keterangan"
					name="keterangan"
				/>
			</div>
			<div class="mb-6">
				<strong class="block mb-4">Unggah Evidence</strong>
				<input type="file" ref="evidence" class="hidden" @change="setFileEvidence" />
				<div class="w-full flex items-center cursor-pointer rounded-l-md" @click="$refs['evidence'].click()" style="border: 1px solid #ccc;overflow: hidden">
					<vs-button icon-pack="feather" icon="icon-upload" class="rounded-l-md rounded-r-none"></vs-button>
					<span class="pl-4">{{ file_evidence_name }}</span>
				</div>
			</div>
			
			<div class="vx-row justify-center md:justify-end">
				<div class="vx-col w-full md:w-1/2">
					<vs-button class="w-full" @click.prevent="submit">
						Selanjutnya
					</vs-button>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
	import { Validator } from 'vee-validate'
	import vSelect from 'vue-select'

	const dict = {
		  custom: {
		    tipe: {
		      required: 'Harap pilih tipe pengajuan dana'
		    },
		    jumlah_kebutuhan: {
		    	required: 'Harap masukan jumlah kebutuhan anda',
				min_value: 'Minimal jumlah kebutuhan Rp 1.000'
		    },
		    deskripsi_kebutuhan: {
		    	required: 'Harap masukan kebutuhan anda'
		    }
		  }
	}

	Validator.localize('en', dict)
	export default {
		components: {
			vSelect
		},
		methods: {
			submit() {
				if(this.file_evidence === null ){
					 this.$vs.notify({
					 	title: 'Harap pilih file evidence anda',
					 	text: '',
					 	color: 'warning',
					 	position: 'top-right'
					 })

					 return false
				}

				this.$validator.validateAll().then(res => {
					if(res) {
						// save 
						this.$emit('submit', {
							tipe: this.tipe,
							deskripsi_kebutuhan: this.deskripsi_kebutuhan,
							jumlah_kebutuhan: this.jumlah_kebutuhan,
							keterangan: this.keterangan
						});
					}
				});
			},
			setFileEvidence() {
				const file = this.$refs['evidence'].files[0]
				this.file_evidence = file
				this.file_evidence_name = file.name
				let arrFileName = file.name.split('.'),
				ext = arrFileName[arrFileName.length - 1].toLowerCase()

				if (!['pdf', 'docx', 'doc', 'jpg', 'png', 'jpeg', 'gif'].includes(ext)) {
					this.file_evidence = null
					this.file_evidence_name = null

					this.$vs.notify({
					  title: 'File tidak diperbolehkan',
					  text: 'Harap upload dokumen atau gambar',
					  color: 'danger',
					  position: 'top-right'
					})

					return false
				}

				this.$emit('setFileEvidence', this.file_evidence)
			}
		},
		data:() => ({
			file_evidence: null,
			file_evidence_name: null,
			jumlah_kebutuhan: 0,
			keterangan: null,
			deskripsi_kebutuhan: null,
			tipe: null,
			tipeOptions: ['Uang Tunai', 'Barang']
		})
	}
</script>